import { render, staticRenderFns } from "./GC.vue?vue&type=template&id=03b9081a&scoped=true&"
import script from "./GC.vue?vue&type=script&lang=js&"
export * from "./GC.vue?vue&type=script&lang=js&"
import style0 from "./GC.vue?vue&type=style&index=0&id=03b9081a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9081a",
  null
  
)

export default component.exports